import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PersonFollowButton } from 'javascripts/components/person_follow_button';
import { SecondaryMenu } from 'javascripts/components/secondary_menu';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import styles from 'stylesheets/components/person_summary.module';

export function PersonSummary({
  dotMenuOptions,
  onFollowChange,
  onFollowError,
  person,
  showButtons,
  trackingCategory,
  displayOrientation,
}) {
  function renderSecondaryMenu() {
    if (dotMenuOptions.length === 0) {
      return null;
    }

    return (
      <div className={styles.dotMenu} onClick={event => event.preventDefault()}>
        <SecondaryMenu
          iconSize='medium'
          options={dotMenuOptions}
          trackingAction='Selected secondary menu option'
          trackingCategory={trackingCategory}
        />
      </div>
    );
  }

  function renderButtons() {
    return (
      <div className={styles.buttons}>
        <PersonFollowButton
          onFollowChange={onFollowChange}
          onError={onFollowError}
          person={person}
          trackingCategory={trackingCategory}
        />
        {renderSecondaryMenu()}
      </div>
    );
  }

  return (
    <div className={classNames(styles.personSummary, { [styles.vertical]: displayOrientation === 'vertical' })}>
      <div className={styles.personInfo}>
        <div className={styles.personLabel}>{person.typeDescription}</div>
        <div className={styles.personName}>{person.name}</div>
      </div>
      {showButtons && renderButtons()}
    </div>
  );
}

PersonSummary.propTypes = {
  dotMenuOptions: PropTypes.arrayOf(PropTypes.shape),
  onFollowChange: PropTypes.func,
  onFollowError: PropTypes.func,
  person: ChirpPropShapes.author.isRequired,
  trackingCategory: PropTypes.string.isRequired,
  displayOrientation: PropTypes.oneOf(['horizontal', 'vertical']),
  showButtons: PropTypes.bool,
};

PersonSummary.defaultProps = {
  dotMenuOptions: [],
  displayOrientation: 'horizontal',
  showButtons: true,
};
